export const ORDER_STATUS = {
  PENDING: {
    value: 0,
    label: "Pending"
  },
  CONFIRMED: {
    value: 1,
    label: "Confirmed"
  },
  DELIVERING: {
    value: 2,
    label: "Delivering"
  },
  DELIVERED: {
    value: 3,
    label: "Delivered"
  },
  CANCELLED: {
    value: 4,
    label: "Cancelled"
  },
  REFUNDING: {
    value: 5,
    label: "Refunding"
  },
  REFUNDED: {
    value: 6,
    label: "Refunded"
  },
  SUCCEEDED: {
    value: 7,
    label: "Succeeded"
  },
  SETTLED: {
    value: 8,
    label: "Settled"
  },
  WAITING_FOR_PAYMENT: {
    value: 9,
    label: "Waiting for payment"
  },
  REJECTED: {
    value: 10,
    label: "Rejected"
  },
  EXPIRED: {
    value: 11,
    label: "Expired"
  },
  ON_GOING: {
    value: 12,
    label: "On going"
  },
  COMPLETED: {
    value: 13,
    label: "Completed"
  },
  USER_PICKED_UP: {
    value: 14,
    label: "User picked up"
  },
  PREPARED: {
    value: 15,
    label: "Prepared"
  },
  PAID: {
    value: 16,
    label: "Paid"
  },
  REFUND_REJECTED: {
    value: 17,
    label: "Refund refused"
  },
  PREPARING: {
    value: 18,
    label: "Preparing"
  },
  ALLOCATING: {
    value: 19,
    label: "Allocating"
  },
  PRE_ORDER: {
    value: 20,
    label: "Pre Order"
  },
}

export const getOrderStatus = (status: number) => {
  const keyOrder = Object.keys(ORDER_STATUS).find((key: string) =>
    ORDER_STATUS[key as keyof typeof ORDER_STATUS].value === status)

  return keyOrder ? ORDER_STATUS[keyOrder as keyof typeof ORDER_STATUS].label : "";
};

export const getStatusColor = (status?: number) => {
  switch (status) {
    case ORDER_STATUS.ON_GOING.value:
    case ORDER_STATUS.REFUNDING.value:
      return "#FCD298";
    case ORDER_STATUS.CONFIRMED.value:
    case ORDER_STATUS.DELIVERED.value:
    case ORDER_STATUS.SUCCEEDED.value:
    case ORDER_STATUS.COMPLETED.value:
    case ORDER_STATUS.SETTLED.value:
    case ORDER_STATUS.USER_PICKED_UP.value:
      return "#12B76A";
    case ORDER_STATUS.DELIVERING.value:
    case ORDER_STATUS.WAITING_FOR_PAYMENT.value:
      return "#fff";
    case ORDER_STATUS.REFUNDED.value:
    case ORDER_STATUS.REJECTED.value:
    default:
      return "#F25A5A";
  }
};

export const ON_GOING_STATUS = [
  ORDER_STATUS.PENDING.value,
  ORDER_STATUS.CONFIRMED.value,
  ORDER_STATUS.DELIVERING.value,
  ORDER_STATUS.REFUNDING.value,
  ORDER_STATUS.WAITING_FOR_PAYMENT.value,
  ORDER_STATUS.ON_GOING.value,
  ORDER_STATUS.PREPARED.value,
  ORDER_STATUS.PAID.value,
];

export enum OrderTrackingType {
  ORDER = "ORDER",
  PRE_ORDER = "PRE_ORDER"
}

export const CANCEL_STATUS = [ORDER_STATUS.CANCELLED.value, ORDER_STATUS.REJECTED.value, ORDER_STATUS.EXPIRED.value];
